import React, { useState, useEffect } from "react";
import { GelfServiceReporter } from "@web/decorators/lib/decorators/tracer/reporters/GelfServiceReporter";
import { closeModal } from "../../../../js/atoms/modals/utils";
import { LiveFeedbackQuestions as LiveFeedbackQuestionsContainer } from "../container";
import { ProviderWrapper } from "../../../common";
import { DomestikaProvider } from "../../../DomestikaContext";
import { contextFactory } from "../../../context";
import { getLang } from "../../../../js/utils/functions";
import {
  setupHoneybadger,
  removeHoneybadger,
} from "../../../../js/utils/errorTracking/honeybadger";
import When from "../../../common/When";

if (window.ENV.GELF_SERVICE_URL) {
  window.__DOMESTIKA_DECORATOR_TRACER_REPORTER__ = GelfServiceReporter.create({
    service: window.ENV.GELF_SERVICE_URL.replace(/\/$/, ""),
  });
}

const LiveFeedbackQuestions = (props) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [context, setContext] = useState();

  const createContext = async () => {
    const { domain } = await contextFactory({ language: getLang });
    await domain.CurrentWithoutRelationshipsUserUseCase.execute();
    setContext(domain);
  };

  const onCloseModal = () => {
    const modalTarget = document.querySelector(".js-modal.live-feedback-questions");
    closeModal(modalTarget);
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  useEffect(() => {
    createContext();
    setupHoneybadger();
    setModalOpen(true);

    document.addEventListener("modal.live_feedback_questions.close", () => {
      setModalOpen(false);
      removeHoneybadger();
    });
  }, []);

  return (
    <When condition={!!context}>
      {() => (
        <DomestikaProvider value={context}>
          <ProviderWrapper>
            <>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              {isModalOpen && <LiveFeedbackQuestionsContainer {...props} onCloseModal={onCloseModal}/>}
            </>
          </ProviderWrapper>
        </DomestikaProvider>
      )}
    </When>
  );
};

export default LiveFeedbackQuestions;
